import { useCallback } from 'react'
import OptionSelect from './OptionSelect'
import { plans } from 'src/enviroment/constants/constants'
import { Tenant } from 'src/types/tenant'
import { api } from 'src/api/root'
import { SubscriptionPlanType } from '../../types/subscription'

interface PlanSelectProps {
  value: SubscriptionPlanType
  tenant: Tenant
  className?: string
}

const PlanSelect = ({ value, tenant, className }: PlanSelectProps) => {
  const { mutateAsync } = api.superAdmin.updateTenant.useMutation()

  const onPlanChange = useCallback(
    async (newPlan: SubscriptionPlanType) => {
      await mutateAsync({ id: tenant.id, plan: newPlan })
    },
    [mutateAsync, tenant.id],
  )

  return (
    <OptionSelect
      value={value}
      options={plans}
      onChange={onPlanChange}
      placeholder="Select Plan"
      className={className}
    />
  )
}

export default PlanSelect
